import { css } from 'styled-components';

export const activePopupBackdropCss = css`

  > .backdrop {
    overflow: hidden;
    pointer-events: none;

    > .backdrop-layer {
      background-color: rgba(255,255,255,0.75);
      opacity: 0.6;
      pointer-events: none;
      z-index: 1;
    }
`;
